import { render } from "./generaux.vue?vue&type=template&id=2b563e28&scoped=true"
import script from "./generaux.vue?vue&type=script&lang=js"
export * from "./generaux.vue?vue&type=script&lang=js"

import "./generaux.vue?vue&type=style&index=0&id=2b563e28&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b563e28"]])

export default __exports__